import HomePage from "./HomePage/HomePage";
import OurVision from "./OurVision/OurVision";
import classes from "./LandingPage.module.scss";
import VideoSection from "./VideoSection/VideoSection";
import LinksSection from "./LinksSection/LinksSection";
import SeBackgroundHoverCards from "../../Components/SeBackgroundHoverCards/SeBackgroundHoverCards";
import WhoWeWorkWith from "./WhoWeWorkWith/WhoWeWorkWith";
import OurAssociation from "./OurAssociation/OurAssociation";
import OrnamentalImage from "./OrnamentalImage/OrnamentalImage";
import GetInTouch from "../../Components/GetInTouch/GetInTouch";
import GlobalPresence from "./GlobalPresence/GlobalPresence";
import SectorsWeCover from "./SectorsWeCover/SectorsWeCover";
import NewsPlatforms from "./NewsPlatforms/NewsPlatforms";
import OurStrategy from "./OurStrategy/OurStrategy";

const LandingPage = () => {
  return (
    <div className={classes["landingpage-container"]}>
      <HomePage />
      <OurVision />
      {/* <VideoSection /> */}
      <GlobalPresence />

      <LinksSection />

      {/* <WhoWeWorkWith /> */}

      {/* <SeBackgroundHoverCards
        title="Who We Work With"
        subTitle="We serve businesses, buyers, and lenders, providing tailored solutions to simplify and accelerate their path to achieving Net-Zero through effective transition strategies."
        cardsContainerHeight={490}
        cards={[
          {
            title: "Business Owners",
            desc: "We assist business owners in shifting to low-carbon practices by creating a detailed and comprehensive transition analysis plan. This plan helps businesses achieve their Net-Zero targets effectively.",
          },
          {
            title: "Lenders",
            desc: "Our goal is to bridge the economic gap between lenders and buyers. By providing a clear transition analysis plan, we make it easier for lenders to finance towards a Net-Zero economy.",
          },
          {
            title: "Buyers",
            desc: "By providing a clear transition analysis plan and bridging the economic gap between stakeholders, we aim to streamline the resource access process for buyers.",
          },
          {
            title: "Advisors",
            desc: "We offer insights and tools to navigate clean energy transitions, providing end-to-end solutions from identifying opportunities to executing profitable strategies, making us a key resource for those advising on sustainable investments and development.",
          },
        ]}
      /> */}

      {/* <OurStrategy /> */}

      <SectorsWeCover />

      <OurStrategy />

      <OurAssociation />

      <NewsPlatforms />

      <GetInTouch />
    </div>
  );
};

export default LandingPage;
